export const gameCategories = [
    'Shooter',
    'Racing',
    'Strategy',
    'Other',
];